module.exports = __webpack_public_path__ + "static/mission-04de2a3e21ad45433eb3aad8eb3f649d.svg";